import React, { useState, useEffect, useMemo } from "react";
import { Drawer, Form, Input, Checkbox, notification, Collapse } from "antd";
import axios from "axios";

import RenderGrupoHabilidades from "./RenderGrupoHabilidades";

const { Panel } = Collapse;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerHabilidades = ({ visible, onClose, habilidadesGuardadas, periodoId, disciplinaId, guardarHabilidadesSelecionadas, form }) => {
    const [grupoAberto, setGrupoAberto] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [habilidadesSelecionadas, setHabilidadesSelecionadas] = useState([]);
    const [search, setSearch] = useState("");

    const gruposFiltrados = useMemo(() => {
        if (!search) return grupos;

        return grupos
            .map(grupo => {
                const habilidadesFiltradas = grupo.habilidades.filter(h => h.label.toLowerCase().includes(search.toLowerCase()));

                return {
                    ...grupo,
                    habilidades: habilidadesFiltradas
                };
            })
            .filter(grupo => grupo.habilidades.length > 0);
    }, [search, grupos]);

    const handleCheckboxChange = (habilidadesDoGrupo, selecionadasDoGrupo) => {
        const valoresDoGrupo = habilidadesDoGrupo.map(opt => opt.value);
        const outrasSelecionadas = habilidadesSelecionadas.filter(h => !valoresDoGrupo.includes(h));
        setHabilidadesSelecionadas([...outrasSelecionadas, ...selecionadasDoGrupo]);
    };

    const carregarHabilidades = () => {
        const escolaSelecionada = JSON.parse(localStorage.getItem("escola_selecionada"));

        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-bncc",
            params: {
                estabelecimentoId: escolaSelecionada.id
            }
        })
            .then(response => {
                setGrupos(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar as habilidades da bncc.");
            });
    };

    const toggleSelecionarTudo = (grupo, checked) => {
        let novasSelecionadas;

        if (checked) {
            const valoresGrupo = grupo.habilidades.map(h => h.value);
            novasSelecionadas = Array.from(new Set([...habilidadesSelecionadas, ...valoresGrupo]));
        } else {
            const valoresGrupo = grupo.habilidades.map(h => h.value);
            novasSelecionadas = habilidadesSelecionadas.filter(h => !valoresGrupo.includes(h));
        }

        setHabilidadesSelecionadas(novasSelecionadas);
    };

    const afterVisibleChange = aberto => {
        if (!aberto) {
            setGrupoAberto([]);
        }
    };

    const montarTitulo = grupo => {
        const valoresGrupo = grupo.habilidades.map(h => h.value);
        const valoresSubgrupo = grupo.subgrupos?.flatMap(subgrupo => (subgrupo.habilidades || []).map(h => h.value)) || [];
        const totasHabilidades = [...valoresGrupo, ...valoresSubgrupo];

        const selecionadas = habilidadesSelecionadas.filter(h => totasHabilidades.includes(h));

        const titulo = `${grupo.titulo}${selecionadas.length > 0 ? ` (Selecionadas: ${selecionadas.length})` : ""}`;

        return titulo;
    };

    const calcularTotalHabilidadesSelecionadas = grupo => {
        const totasHabilidades = grupo.habilidades.map(h => h.value);

        const selecionadas = habilidadesSelecionadas.filter(h => totasHabilidades.includes(h));
        const todasSelecionadas = selecionadas.length === totasHabilidades.length;

        return { todasSelecionadas, selecionadas };
    };

    useEffect(() => {
        carregarHabilidades();
    }, []);

    useEffect(() => {
        form.resetFields();

        const habilidades = habilidadesGuardadas.map(habilidade => habilidade.id);

        setHabilidadesSelecionadas(habilidades);
    }, [periodoId, disciplinaId, habilidadesGuardadas]);

    return (
        <Drawer
            title=""
            placement="right"
            className="drawer-habilidades-bncc"
            maskClosable={false}
            closable={true}
            onClose={onClose}
            visible={visible}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <div className="bloco-alerta">
                    <span className="mensagem-alerta">
                        <span className="mensagem-titulo">Habilidades BNCC</span>
                        <span className="mensagem-texto">Selecione abaixo as habilidades associadas a esta disciplina.</span>
                    </span>
                </div>
                <div>
                    <Form className="form-emitir-declaracao">
                        <Form.Item label="Pesquisar habilidades">
                            <Input placeholder="Pesquisar..." value={search} onChange={e => setSearch(e.target.value)} />
                        </Form.Item>
                        <Collapse accordion activeKey={grupoAberto} onChange={setGrupoAberto}>
                            {gruposFiltrados.map(grupo => {
                                const titulo = montarTitulo(grupo);
                                const temSubgrupos = grupo.subgrupos?.length > 0;

                                if (temSubgrupos) {
                                    return (
                                        <Panel header={titulo} key={grupo.titulo}>
                                            <Collapse accordion>
                                                {grupo.subgrupos.map(subgrupo => {
                                                    const titulo = montarTitulo(subgrupo);
                                                    const { todasSelecionadas, selecionadas } =
                                                        calcularTotalHabilidadesSelecionadas(subgrupo);

                                                    return (
                                                        <Panel header={titulo} key={subgrupo.titulo}>
                                                            <RenderGrupoHabilidades
                                                                grupo={subgrupo}
                                                                todasSelecionadas={todasSelecionadas}
                                                                selecionadas={selecionadas}
                                                                onChange={toggleSelecionarTudo}
                                                                handleCheckboxChange={handleCheckboxChange}
                                                            />
                                                        </Panel>
                                                    );
                                                })}
                                                {grupo.habilidades.length > 0 &&
                                                    (() => {
                                                        const { todasSelecionadas, selecionadas } =
                                                            calcularTotalHabilidadesSelecionadas(grupo);
                                                        const titulo = `Sem Subgrupo${selecionadas.length > 0 ? ` (Selecionadas: ${selecionadas.length})` : ""}`;

                                                        return (
                                                            <Panel header={titulo} key="sem-subgrupo">
                                                                <RenderGrupoHabilidades
                                                                    grupo={grupo}
                                                                    todasSelecionadas={todasSelecionadas}
                                                                    selecionadas={selecionadas}
                                                                    onChange={toggleSelecionarTudo}
                                                                    handleCheckboxChange={handleCheckboxChange}
                                                                />
                                                            </Panel>
                                                        );
                                                    })()}
                                            </Collapse>
                                        </Panel>
                                    );
                                } else {
                                    const { todasSelecionadas, selecionadas } = calcularTotalHabilidadesSelecionadas(grupo);

                                    return (
                                        <Panel header={titulo} key={grupo.titulo}>
                                            <RenderGrupoHabilidades
                                                grupo={grupo}
                                                todasSelecionadas={todasSelecionadas}
                                                selecionadas={selecionadas}
                                                onChange={toggleSelecionarTudo}
                                                handleCheckboxChange={handleCheckboxChange}
                                            />
                                        </Panel>
                                    );
                                }
                            })}
                        </Collapse>
                    </Form>
                </div>
            </div>
            <div className="ant-drawer-footer">
                <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </button>
                <button className="botao-principal" onClick={() => guardarHabilidadesSelecionadas(habilidadesSelecionadas)}>
                    Confirmar
                </button>
            </div>
        </Drawer>
    );
};

const FormDrawerHabilidades = Form.create({ name: "drawer-habilidades" })(DrawerHabilidades);

export default FormDrawerHabilidades;
